import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import transportApi from '@/features/dashboard/tourTransport/api/transportApi.ts';
import { transportApiQueryKeys } from '@/features/dashboard/tourTransport/api/transportApi.queryKeys.ts';
import { TransportConfigurationWebDto } from '@/features/dashboard/tourTransport/types/TransportConfigurationDto.ts';

export const getTransportQueryOptions = (
  tourId: string | undefined,
): UseQueryOptions<TransportConfigurationWebDto | null> => ({
  queryKey: transportApiQueryKeys.byTourId(tourId!),
  queryFn: () => transportApi.get(tourId!),
  enabled: !!tourId,
  staleTime: 1000 * 60,
});

const useGetTransport = (tourId: string | undefined) => {
  return useQuery(getTransportQueryOptions(tourId));
};

export default useGetTransport;
